import { useState} from 'react';
import Sidebar from './Components/SideBar';
import Systems from './Components/systems/Systems';
import Rooms from './Components/rooms/Rooms';
import Employees from './Components/employees/Employees';
import Clients from './Components/Clients/Clients';
import Games from './Components/gamesCards/Games';
import Schedule from './Components/Schedule/Schedule';
import Calendar from './Components/calendar/Calendar';
import PrivateGames from './Components/privateGames/PrivateGames';
import { EmployeeProvider } from './context/EmployeeProvider.jsx';
import { EmployeeContext } from './context/EmployeeContext.jsx';
import MobileHeader from './MobileHeader';
import '@/styles/admin.scss';
import AdminPromo from "@/pages/adminPanel/Components/promo/Promo.jsx";
import Slots from "@/pages/adminPanel/Components/slots/Slots.jsx";
import Sertificates from './Components/Sertificates/Sertificates';

const renderContent = (page) => {
    switch (page) {
        case 'employees': return <Employees />;
        case 'clients': return <Clients />;
        case 'systems': return <Systems />;
        case 'room': return <Rooms />;
        case 'games': return <Games />;
        case 'schedule': return <Schedule />;
        case 'calendar': return <Calendar />;
        case 'privateGames': return <PrivateGames />;
        case 'promo': return <AdminPromo />;
        case 'slots': return <Slots />;
        case 'sertificate': return <Sertificates />;
        default: return <Employees />;
    }
};

export default function AdminPanel() {
    const [selectedPage, setSelectedPage] = useState(
        localStorage.getItem('selectedPage') || 'employees'
    );
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setIsSidebarOpen(false);

    return (
        <EmployeeProvider>
            <MobileHeader onBurgerClick={toggleSidebar} />
            <div className="d-flex vh-100" id="admin">
                <Sidebar
                    selectedPage={selectedPage}
                    setSelectedPage={(page) => {
                        setSelectedPage(page);
                        localStorage.setItem('selectedPage', page);
                        closeSidebar();
                    }}
                    isOpen={isSidebarOpen}
                    onClose={closeSidebar}
                />
                <main className="flex-grow-1 bg-light">
                    {renderContent(selectedPage)}
                </main>
            </div>
        </EmployeeProvider>
    );
}
